import { observable } from "mobx";
import { GET } from "lib/api";
import config from "lib/config";
import _ from "lodash";
import { isMangerViewingCoworker } from "lib/luvitUtils";
import qs from "qs";

class NavigationStore {
  @observable
  expanded = false;
  @observable
  active = undefined;
  @observable
  ready = false;
  @observable
  isAdmin = false;
  @observable
  routeUrl = "";
  @observable
  nodes = [];
  @observable
  courses = [];
  @observable
  isUnitAdmin = false;

  constructor() {
    let initialState = JSON.parse(
      luvit.getItem("luvit_portalmenustate") || "{}",
    );
    this.active = initialState.active;
    if (window.matchMedia("(max-width: 1025px)").matches) {
      this.expanded = false;
    } else if (initialState.expanded !== false) {
      this.expanded = true;
    }
  }

  async reload(opts) {
    let force = !!(opts && opts.force);
    if (!force && this.ready) return;

    if (!config.isLoggedIn) {
      this.ready = true;
      this.nodes = [];
      this.courses = [];
      return;
    }

    let sitemenu = await GET("/v1/sitemenu/:siteId", {
      siteId: config.siteId,
    });

    if (config.isCurrentSessionImpersonation) {
      sitemenu = sitemenu.filter((m) => m.itemId !== 1004); // Remove /enteradmin.aspx
    }

    this.nodes = _.fromPairs(_.map(sitemenu, (v, k) => [v.itemId, v]));
    this.courses = await GET("/v1/users/latestcourses/:noOfCourses", {
      noOfCourses: 1000,
    });

    this.isAdmin = await GET("/v1/user/isadmin");
    const talkId = qs.parse(window.location.href.split("?")[1]).talkid;

    if (talkId) {
      this.isUnitAdmin = await GET(`/v1/comptalk/question/${talkId}`);
    }

    this.ready = true;
  }

  expandToggle(newState) {
    this.expanded = newState === undefined ? !this.expanded : newState;
    this.saveState({ active: this.active, expanded: this.expanded });
  }

  activateNode(id) {
    let isMobile = !!window.matchMedia("(max-width: 1025px)").matches;
    if (isMobile) {
      this.expandToggle(false);
    }

    let expanded = !!this.expanded && !isMobile;
    this.saveState({ active: id, expanded });
    this.active = id;
    this.expanded = expanded;
  }

  async handleRouteChange(route) {
    this.routeUrl = route;
    let notPersonalGoalPage = route.indexOf("coworker/personalgoals") === -1;
    let notReportsPage = route.indexOf("educationhistoryreport") === -1;
    if (
      !route ||
      (this.routeUrl !== route && notPersonalGoalPage && notReportsPage)
    )
      return;
    let newUrl = "/" + String(route).toLowerCase();
    let foundNode = _.find(this.nodes, (v) => {
      return newUrl == (v.url || "").toLowerCase();
    });
    let expandedState =
      window.matchMedia("(max-width: 600px)").matches || false
        ? false
        : !!this.expanded;
    if (!foundNode && notPersonalGoalPage && notReportsPage) return;
    if (!isMangerViewingCoworker()) {
      this.expandToggle(expandedState);
      if (foundNode) {
        this.active = foundNode.itemId;
        this.saveState({ active: foundNode.itemId });
      }
    }
  }

  nodeExists(searchNode) {
    let nodes = Object.values(this.nodes);
    return nodes.findIndex((node) => node.name === searchNode) > -1;
  }

  saveState(newState) {
    luvit.setItem("luvit_portalmenustate", JSON.stringify(newState));
  }
}

export default new NavigationStore();
